import React from "react";

import TravellerStepOne from "img/how-to-img/world-tour.png";
import TravellerStepTwo from "img/how-to-img/mailbox.png";
import TravellerStepThree from "img/how-to-img/bill-receipt.png";
import TravellerStepFour from "img/how-to-img/product-delivery-tracking.png";
import TravellerStepFive from "img/how-to-img/delivery-truck.png";

export default function HowToTraveller() {
  return (
    <div className="step-list">
            <h1 className="small-heading">Steps to Register a Customer</h1>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={TravellerStepOne}
            alt="Step One"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 1: Go to Customer Login
          </h1>
          <p className="small-para">
            Head over to the Tripple Air homepage and click on the "Customer
            Login" button, usually located at the top right corner. This will
            redirect you to the customer portal where you can start the
            registration process.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={TravellerStepTwo}
            alt="Step Two"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 2: Click on "Create Account"
          </h1>
          <p className="small-para">
            On the login page, select "Create Account" beneath the sign-in
            fields. This will open the registration form where you'll need to
            provide your details to sign up.
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={TravellerStepThree}
            alt="Step Three"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 3: Fill Out Your Details
          </h1>
          <p className="small-para">
            Enter your full name, email address, phone number, and create a
            secure password. Make sure the information is accurate — it will be
            used for bookings and future communications.
          </p>
        </div>
      </div>
      <div className="step-item icon-right">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={TravellerStepFour}
            alt="Step Four"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 4: Verify Your Email
          </h1>
          <p className="small-para">
            After submitting the form, you'll receive a verification email from
            Tripple Air. Click the link in the email to confirm your account and
            activate your profile.
          </p>
        </div>
      </div>
      <div className="step-item icon-left">
        <div className="step-icon w30">
          <img
            className="step-icon-img"
            src={TravellerStepFive}
            alt="Step Five"
          />
        </div>
        <div className="step-info w70">
          <h1 className="small-heading font-weight-bold mb-2">
            Step 5: Start Exploring & Booking
          </h1>
          <p className="small-para">
            Once verified, log in with your new credentials. You can now browse
            flights, manage bookings, and access exclusive deals tailored just
            for customers.
          </p>
        </div>
      </div>
    </div>
  );
}
